<template>
	<div class="conten">
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true">
				<el-form-item>
					<el-select v-model="secah.adStatus" placeholder="请选择状态" clearable>
					    <el-option label="上线" :value="1"></el-option>
						 <el-option label="下线" :value="2"></el-option>
					  </el-select>
				</el-form-item>
				<el-form-item>
					<el-button @click='secahClick'>搜索</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click='add'>新增</el-button>
				</el-form-item>
			</el-form>
		</el-col>

		<div>
			<el-table :data="tableData" style="width: 100%" border>
				<el-table-column prop="adTitle" label="标题" align="center">
				</el-table-column>
				<el-table-column prop="adDesc" label="描述" align="center">
				</el-table-column>
				<el-table-column prop="bannerStatus" label="状态" align="center">
					<template slot-scope="scope">
						{{scope.row.adStatus==1?"上线":"下线"}}
					</template>
				</el-table-column>
				<el-table-column prop="adSource" label="来源" align="center">
				</el-table-column>
				<el-table-column prop="adPlayCount" label="播放次数" align="center">
				</el-table-column>
				<el-table-column prop="adUrl" label="链接" align="center">
				</el-table-column>
				<el-table-column fixed="right" label="操作" width="150" align="center">
					<template slot-scope="scope">
						<el-button size="mini" @click="edit(scope.row)">编辑</el-button>
						<el-button size="mini" type="danger" @click="del(scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="page">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page.sync="secah.pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="secah.pageSize"
				layout="total, sizes, prev, pager, next, jumper" :total="total">
			</el-pagination>
		</div>
		<el-dialog :close-on-click-modal='false' :close-on-press-escape='false' :title="isAdd?'新增':'修改'"
			:visible.sync="dialogVisible" :modal-append-to-body='false' width="600px">
			<el-form :model="form">
				<el-form-item label="标题" label-width='100px'>
					<el-input v-model="form.adTitle" maxlength="18" autocomplete="off" placeholder="请输入标题"></el-input>
				</el-form-item>
				<el-form-item label="描述" label-width='100px'>
					<el-input v-model="form.adDesc" maxlength="10" autocomplete="off" placeholder="请输入描述">
					</el-input>
				</el-form-item>
				<el-form-item label="链接" label-width='100px'>
					<el-input v-model="form.adUrl" maxlength="10" autocomplete="off" placeholder="请输入链接">
					</el-input>
				</el-form-item>
				<el-form-item label="来源" label-width='100px'>
					<el-input v-model="form.adSource" maxlength="10" autocomplete="off" placeholder="请输入来源">
					</el-input>
				</el-form-item>
				<el-form-item  label="状态" label-width='100px'>
					<el-select v-model="form.adStatus" placeholder="请选择状态" clearable>
					    <el-option label="上线" :value="1"></el-option>
						 <el-option label="下线" :value="2"></el-option>
					  </el-select>
				</el-form-item>				
				<el-form-item label="视频上传" label-width='100px'>
				  <!-- action必选参数, 上传的地址 -->
				    <el-upload class="avatar-uploader el-upload--text" :action="upImg+'/upload/batch/video'" :show-file-list="false" :on-success="handleAvatarSuccess"
					 :headers="headers" :on-error='onError' 
					 :before-upload="beforeUploadVideo" >
				        <video v-if="form.adVideoPath!=''" :src="webUrl+form.adVideoPath" class="avatar" controls="controls">您的浏览器不支持视频播放</video>
				        <i v-else="form.adVideoPath" class="el-icon-plus avatar-uploader-icon"></i>				        
				    </el-upload>
				</el-form-item>

			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="sub">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				tableData: [],
				total: 0,
				dialogVisible: false,
				isAdd: true,
				webUrl: this.webUrl,
				headers:{
					'token':this.$store.state.token,
					// 'Content-Type': 'multipart/form-data'
				},
				secah: {
					adPurpose:1,
					pageSize: 10,
					pageNum: 1,
					adStatus: ""
				},
				form: {
					"adPurpose":1,
					"adDesc": "",
					"adId": "",
					"adSource": "",
					"adStatus": 1,
					"adTitle": "",
					"adUrl": "",
					"adVideoPath": ""
				},

			}
		},
		created() {
			this.getAdvertisement()
		},
		methods: {
			//搜索
			secahClick() {
				this.secah.pageNum = 1
				this.getAdvertisement()
			},
			//新增
			add() {
				this.dialogVisible = true
				this.isAdd = true
				this.form = {
					"adPurpose":1,
					"adDesc": "",
					"adId": "",
					"adSource": "",
					"adStatus": 1,
					"adTitle": "",
					"adUrl": "",
					"adVideoPath": ""
				}
			},
			//提交
			sub() {
				if (this.form.adStatus == '') {
					this.$message('请选择状态');
					return false
				}
				if(this.form.adUrl.length == 0 && this.form.adVideoPath.length == 0){
					this.$message('请输入广告链接或上传视频');
				}
				console.log(JSON.stringify(this.form))								
				var url=this.isAdd?"/ad/add":"/ad/update"
				if (this.isAdd) {
					this.httpPost(url, this.form, true, {
						'Content-Type': 'application/json'
					}).then(res => {
						if (res.code == 200) {
							this.$message.success('新增成功');
							this.dialogVisible = false
							this.getAdvertisement()
						}
					})
				} else {
					this.httpPut(url, this.form, true, {
						'Content-Type': 'application/json'
					}).then(res => {
						if (res.code == 200) {
							this.$message.success('修改成功');
							this.dialogVisible = false
							this.getAdvertisement()
						}
					})
				}

			},

			//删除
			del(row) {
				console.log(row);
				this.$confirm('此操作将永久删除, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.httpDel("/ad/del?" + this.$qs.stringify({
						adId: row.adId
					})).then(res => {
						if (res.code == 200) {
							this.$message.success('删除成功');
							this.getAdvertisement()
						}
					})
				}).catch(() => {
					// this.$message({
					// 	type: 'info',
					// 	message: '已取消删除'
					// });
				});
			},
			//修改
			edit(row) {
				this.dialogVisible = true
				this.isAdd = false
				this.form = JSON.parse(JSON.stringify(row))
				// this.form.password=''

			},
			//上传封面图片回调
			handleAvatarSuccess(res, file) {
				this.form.adVideoPath = res.data.path0
				console.log(this.form)
				this.$message.success("上传成功")
			},
			onError(){
				this.$message.error("上传失败")
			},
			beforeUploadVideo(file) {
			    const isLt10M = file.size / 1024 / 1024  < 10;
			    if (['video/mp4', 'video/ogg', 'video/flv','video/avi','video/wmv','video/rmvb'].indexOf(file.type) == -1) {
			        this.$message.error('请上传正确的视频格式');
			        return false;
			    }
			    if (!isLt10M) {
			        this.$message.error('上传视频大小不能超过10MB哦!');
			        return false;
			    }
			},

			//选择分页条数
			handleSizeChange(e) {
				this.secah.pageNum = 1
				this.secah.pageSize = e
				this.getAdvertisement()
			},
			//页码
			handleCurrentChange(e) {
				this.secah.pageNum = e
				this.getAdvertisement()
			},
			//获取数据
			getAdvertisement() {
				this.httpPost("/ad/listByPage", this.secah, true, {
					'Content-Type': 'application/json'
				}).then(res => {
					if (res.code == 200) {
						this.tableData = res.data.content
						this.total = res.data.total
					}
				})

			},


		},


	}
</script>

<style scoped lang='scss'>
	.page {
		padding: 20px 0;
	}

	.avatar-uploader .el-upload {
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		border: 1px solid #d9d9d9 !important;
		line-height: 178px !important;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}
</style>
